<div class="settingContainer">

  <mat-card class="menupannel">
    <button mat-flat-button  (click)="openSettingSidebar = !openSettingSidebar" >
      <mat-icon color="primary">menu</mat-icon> Settings
    </button>
    
  </mat-card>

    <!-- Side Bar -->
    <mat-card class="settingsidebar" [ngClass]="{ open: openSettingSidebar }">
      <app-side-navigation></app-side-navigation>
    </mat-card>
    <!-- Side Bar -->
  

    

    <div class="settingsidebarOverlay" (click)="openSettingSidebar = !openSettingSidebar"
      [ngClass]="{ open: openSettingSidebar }"></div>

      <div class="inner_wrapper settingtab" (scroll) = "onScroll()">

        <router-outlet></router-outlet>

      </div>


</div>
